import { styled } from '@mui/material';

export const InputContainer = styled('div')(() => ({
  width: '85%',
  display: 'flex',
}));

export const Container = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1.5rem',
  width: '100%',
}));
